<template>
  <div id="app">
    <router-view />
    <modal-error />
    <modal-manual-calculation />
    <modal-not-all-data-available />
  </div>
</template>
<style>
  body, html {
    background-color: white !important;
  }
</style>
<script>
import { mapState } from 'vuex';
import ModalError from '@/modals/modal-error.vue';
import ModalManualCalculation from '@/modals/modal-manual-calculation.vue';
import ModalNotAllDataAvailable from '@/modals/modal-not-all-data-available.vue';

export default {
  components: {
    ModalError,
    ModalManualCalculation,
    ModalNotAllDataAvailable,
  },
  computed: {
    ...mapState('general', ['error', 'manualCalculation', 'notAllData']),
  },
  watch: {
    error(value) {
      if (value) {
        this.$modal.show('modal-error');
      }
    },
    manualCalculation(value) {
      if (value) {
        this.$modal.show('modal-manual-calculation');
      }
    },
    notAllData(value) {
      if (value) {
        this.$modal.show('modal-not-all-data-available');
      }
    },
  },
};
</script>

<style lang="scss">
  @import "./scss/baloise-ui.scss";
</style>
